import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { fetchUserQualificationsByType } from "../../../services/api/user";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { UserType } from "../../../utils/enum";
import useAuth from "../../../hooks/useAuth";
import AddBackgroundVerificationModal from "../../CompleteYourProfile/components/AddBackgroundVerificationModal";

const BackgroundVerification = ({ backgroundCheckId }) => {
  const { id: userId } = useParams();
  const { authRole } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    data: userQualificationsData,
    isPending: isUserQualificationsApiLoading,
    error: isUserQualificationsApiError,
    refetch: refetchUserQualificationsByType,
  } = useQuery({
    queryKey: ["equipment", userId, backgroundCheckId],
    queryFn: () => fetchUserQualificationsByType(userId, backgroundCheckId),
    enabled: !!userId && !!backgroundCheckId,
  });

  return (
    <BaseCard className="py-2 px-8 sm:px-10 rounded-lg" elevation={1}>
      <div className="bg-light -mx-4 px-4 py-2 mt-2 mb-4 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Background Verification</h6>
        {authRole === UserType.ADMIN && (
          <i
            className="fa-solid fa-circle-plus cursor-pointer text-lg text-secondary"
            style={{ cursor: "pointer" }}
            onClick={() => setIsModalOpen(true)}
          ></i>
        )}
      </div>

      <div className="grid grid-cols-3 gap-x-8">
        {userQualificationsData?.data?.map((backgroundCheck) => (
          <BaseCard key={backgroundCheck.id} className="md:col-span-1 col-span-3 shadow-md mb-4">
            <div className="flex items-center justify-between py-2 px-4">
              <a
                href={backgroundCheck?.url}
                download
                target="_blank"
                type="application/octet-stream"
              >
                <p className="font-normal cursor-pointer hover:text-primary hover:underline">
                  {backgroundCheck?.qualificationSubType}
                </p>
              </a>
            </div>
          </BaseCard>
        ))}
      </div>

      {isModalOpen && (
        <AddBackgroundVerificationModal
          open={isModalOpen}
          close={setIsModalOpen}
          refetchUserQualificationsByType={refetchUserQualificationsByType}
          backgroundCheckId={backgroundCheckId}
          targetUserId={userId}
        />
      )}
    </BaseCard>
  );
};

export default BackgroundVerification;
